/**
 * W10 — Withdrawal quote: BDT 300 minimum. A withdrawal request no longer carries a fee: the flat 5% service charge is
 * taken once, when Available commission is processed for withdrawal (see processWithdrawal.ts).
 * Pure domain logic; NaN/negative input yields a validation error, never NaN output.
 */

/** Single source of truth for the minimum gross withdrawal (BDT). Checked against money already net of the 5% charge. */
export const MIN_WITHDRAWAL = 300;
/** Rate of the one-time processing service charge, as a whole percent for exact integer-paisa arithmetic. */
export const SERVICE_CHARGE_PERCENT = 5;


export interface WithdrawalQuote {
  grossAmount: number;
  feeAmount: number;
  netAmount: number;
}

export type WithdrawalQuoteResult =
  | { ok: true; quote: WithdrawalQuote }
  | { ok: false; reason: 'not-a-number' | 'below-minimum' | 'exceeds-balance' };

export function quoteWithdrawal(
  gross: number,
  availableBalance?: number,
): WithdrawalQuoteResult {
  if (!Number.isFinite(gross) || gross <= 0) return { ok: false, reason: 'not-a-number' };
  if (gross < MIN_WITHDRAWAL) return { ok: false, reason: 'below-minimum' };
  if (availableBalance !== undefined && gross > availableBalance) {
    return { ok: false, reason: 'exceeds-balance' };
  }
  return {
    ok: true,
    quote: { grossAmount: gross, feeAmount: 0, netAmount: gross },
  };
}
